import { render, staticRenderFns } from "./dynamic-page.vue?vue&type=template&id=6ba1bb02"
import script from "./dynamic-page.vue?vue&type=script&lang=js"
export * from "./dynamic-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports